import styled from 'styled-components';

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailLine = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`;

export const DeltaDetailLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 4px;
`;

export const DeltaStoresContent = styled.span`
  flex: 1;
  min-width: 0;
  font: ${({ theme }) => theme.fonts.textSmallHeight14};
`;

export const Arrow = styled.span`
  margin: 0 2px;
  font: ${({ theme }) => theme.fonts.textSmallHeight14};
`;

export const DeltaSign = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  flex-shrink: 0;
  font: ${({ theme }) => theme.fonts.textSmallHeight14};
`;
